import xlsx from 'xlsx'
import Vue from 'vue'
Vue.use(xlsx)
Vue.prototype.XLSX = xlsx
